














































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { Ax } from "@/utils";
import VueElementLoading from "vue-element-loading";

type SortDirection = "asc" | "desc";
type SortableModalField = "name" | "expense_code" | "bip_code";
type SortableTableField =
    | "nom_dog"
    | "item_description"
    | "expense_code"
    | "project_name"
    | "abp"
    | "gu"
    | "stage";
type SortableField = SortableTableField | SortableModalField | null;
interface TableField {
    key: string;
    label: string;
    sortable: boolean;
    width: string;
}

interface ProjectsMonRequest {
    user_id: number | string;
    year: number;
    region: string;
    abp: number | null;
    gu: string | null;
    prg: number | null;
    dev_type: number;
    stage: string[] | null;
    expense_code: string | null;
}
interface ProjectsMonReport {
    params: ProjectsMonRequest;
    region_name: string;
    locale: string;
}

interface SaveProjectRequest {
    region: string;
    gu: string;
    year: number;
    abp: number;
    prg: number;
    expense_code: string | null;
    bip_code: string | null;
    stage: string | null;
    nom_dog: string;
    date_dog: string | null;
    spf: number | null;
    user_id: string;
}

@Component({
    name: "projectMonitoring",
    components: {
        loading: VueElementLoading,
    },
})
export default class ProjectMonitoring extends Vue {
    $refs!: {
        drop: any;
        [key: string]: any;
    };
    private user_id: string = "";
    private module_code: string = "005.003.009";
    private access_level: number = 0;
    private year: number = new Date().getFullYear();
    private region: any = null;
    private abp: any = null;
    private gu: any = null;
    private prg: any = null;
    private stage: any[] = [];
    private modalStages: any[] = [];
    private stages: any = [];
    private project: any = null;
    private is_project_linked: any = "all";
    private dev_type: number = 2;
    private loading: boolean = false;

    async created() {
        this.user_id = this.$store.getters.user.sub;
        for (const avModule of this.$store.state.user.userModules) {
            if (avModule.modules === this.module_code) {
                if (avModule.access_level !== null) {
                    this.access_level = avModule.access_level;
                }
                break;
            }
        }
        await this.loadYears();
        await this.getContractStages();
    }

    private yearBase: number[] = [];
    private regionBase: any[] = [];
    private abpBase: any[] = [];
    private guBase: any[] = [];
    private prgBase: any[] = [];
    private projectBase: any[] = [];
    private guNameCache: Record<string, string> = {};
    private guNameCacheKk: Record<string, string> = {};

    private get developes() {
        return [
            {
                text: this.$t(
                    "modules.budget_execution_monitoring.projects_monitoring.filter.prg_type.all"
                ),
                code: 2,
            },
            {
                text: this.$t(
                    "modules.budget_execution_monitoring.projects_monitoring.filter.prg_type.current"
                ),

                code: 0,
            },
            {
                text: this.$t(
                    "modules.budget_execution_monitoring.projects_monitoring.filter.prg_type.develop"
                ),
                code: 1,
            },
        ];
    }

    private get developTypeText(): string {
        const found = this.developes.find((d) => d.code === this.dev_type);
        return String(found?.text ?? "");
    }

    private get selectedStageCodes(): string[] | null {
        const codes = (this.stage || [])
            .map((s: any) => s?.code)
            .filter((code: any) => code !== null && code !== undefined);
        return codes.length > 0 ? codes : null;
    }

    private get stageBreadcrumbText(): string {
        return this.selectedStageCodes?.join(", ") ?? "";
    }

    private onStageSelect(selectedOption: any) {
        if (selectedOption?.code === null) {
            this.stage = [selectedOption];
            return;
        }

        const selectedStages = (this.stage || []).filter(
            (s: any) => s?.code !== null
        );

        // Защита от дублирования
        if (
            !selectedStages.some(
                (s: any) => String(s.code) === String(selectedOption.code)
            )
        ) {
            selectedStages.push(selectedOption);
        }

        this.stage = selectedStages;
    }

    private onStageRemove(removedOption: any) {
        this.stage = (this.stage || []).filter(
            (s: any) => String(s?.code) !== String(removedOption?.code)
        );

        if (this.stage.length === 0) {
            const allOption = this.stages.find((s: any) => s.code === null);

            if (allOption) {
                this.stage = [allOption];
            }
        }
    }

    private get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    private msgPath: string =
        "modules.budget_execution_monitoring.projects_monitoring.messages";

    private formatDate(value: string | null): string {
        if (!value) return "";
        const [y, m, d] = String(value).slice(0, 10).split("-");
        return y && m && d ? `${d}.${m}.${y}` : String(value);
    }

    private getSpfName(row: any): string {
        return row[`spf_name_${this.curLanguage}`] || row.spf_name_ru || "";
    }

    private isBindingFromPastYear(row: any): boolean {
        return row.binding_year != null && this.year > row.binding_year;
    }

    private get isBoundProjectMissing(): boolean {
        return this.available_projects.some((pr: any) => pr.notInTransfers);
    }

    private get modalHint(): "apply" | "remove" | null {
        if (this.available_projects.some((pr: any) => pr.selected)) {
            return "apply";
        }
        return this.curExpense?.expense_code ? "remove" : null;
    }

    private tableFields: TableField[] = [
        {
            key: "num",
            label: "num",
            sortable: false,
            width: "10px",
        },
        {
            key: "abp",
            label: "abp",
            sortable: false,
            width: "50px",
        },
        {
            key: "prg",
            label: "prg",
            sortable: false,
            width: "50px",
        },
        {
            key: "gu",
            label: "gu",
            sortable: false,
            width: "150px",
        },
        {
            key: "nom_dog",
            label: "nom_dog",
            sortable: true,
            width: "100px",
        },
        {
            key: "item_description",
            label: "item_description",
            sortable: true,
            width: "150px",
        },
        {
            key: "expense_code",
            label: "expense_code",
            sortable: true,
            width: "100px",
        },
        {
            key: "bip_code",
            label: "bip_code",
            sortable: true,
            width: "80px",
        },
        {
            key: "project_name",
            label: "project_name",
            sortable: true,
            width: "100px",
        },
        {
            key: "stage",
            label: "stage",
            sortable: false,
            width: "100px",
        },
    ];

    private modalTableFields: TableField[] = [
        {
            key: "expense_code",
            label: "code",
            sortable: true,
            width: "100px",
        },
        {
            key: "project_name",
            label: "project_name",
            sortable: false,
            width: "auto",
        },
    ];
    private curPage: number = 1;
    private perPage: number = 50;
    private tableData: any[] = [];
    private sortField: SortableField = null;
    private sortDirection: SortDirection = "desc";
    private sortModalField: SortableField = null;
    private sortModalDirection: SortDirection = "desc";
    private sortCode(field: SortableField) {
        if (this.sortField === field) {
            if (this.sortDirection === "asc") {
                this.sortDirection = "desc";
                this.sortField = null;
            } else if (this.sortDirection === "desc") {
                this.sortDirection = "asc";
            }
        } else {
            this.sortField = field;
            this.sortDirection = "desc";
        }
    }
    private sortCodeModal(field: SortableField) {
        if (this.sortModalField === field) {
            if (this.sortModalDirection === "asc") {
                this.sortModalDirection = "desc";
                this.sortModalField = null;
            } else if (this.sortModalDirection === "desc") {
                this.sortModalDirection = "asc";
            }
        } else {
            this.sortModalField = field;
            this.sortModalDirection = "desc";
        }
    }

    private sortByField(field: string, direction: SortDirection) {
        return (a: any, b: any) => {
            const valueA = a[field];
            const valueB = b[field];

            if (valueA == null && valueB == null) return 0;

            if (valueA == null) return 1;
            if (valueB == null) return -1;

            const strA = valueA.toString();
            const strB = valueB.toString();

            return direction === "asc"
                ? strA.localeCompare(strB)
                : strB.localeCompare(strA);
        };
    }

    private sortTable(
        table: any[],
        sortField: SortableField,
        sortDirection: SortDirection
    ) {
        if (sortField) {
            return [...table].sort(this.sortByField(sortField, sortDirection));
        }
        return table;
    }

    private get getFilteredTableData() {
        const data = this.sortTable(
            this.tableData,
            this.sortField,
            this.sortDirection
        );

        return data.filter((v: any) => {
            if (this.is_project_linked === "linked") {
                return v.expense_code !== null;
            } else if (this.is_project_linked === "not_linked") {
                return v.expense_code === null;
            } else {
                return true;
            }
        });
    }

    private get paginateTable() {
        const start = (this.curPage - 1) * this.perPage;
        const end = start + this.perPage;
        return this.getFilteredTableData.slice(start, end);
    }

    private async loadGuNames(codes: string[]) {
        if (!codes.length) return;

        const { data } = await axios.post("/api-py/get-guNames-by-codes", {
            year: this.year,
            codes,
        });

        data.forEach((gu: any) => {
            this.guNameCache[gu.code] = `${gu.code} - ${gu.name_ru}`;
            this.guNameCacheKk[gu.code] = `${gu.code} - ${
                gu.name_kk ?? gu.name_ru
            }`;
        });
    }

    private async loadData() {
        if (!this.region?.code) {
            this.makeToast("danger", "Внимание!", "Введите регион и год!");
            return;
        }

        this.curPage = 1;

        const req: ProjectsMonRequest = {
            user_id: this.user_id,
            year: this.year,
            region: this.region.code,
            abp: this.abp?.abp ?? null,
            gu: this.gu?.gu ?? null,
            prg: this.prg?.prg ?? null,
            dev_type: this.dev_type,
            stage: this.selectedStageCodes,
            expense_code: this.project?.expense_code ?? null,
        };

        try {
            this.tableData = [];

            const { data } = await axios.post(
                "/api-py/monitoring/projects/data/409",
                req
            );

            const guCodes: any = [
                ...new Set(
                    data
                        .map((item: any) => item.gu)
                        .filter(
                            (code: string) => code && !this.guNameCache[code]
                        )
                ),
            ];

            await this.loadGuNames(guCodes);

            this.tableData = data;
        } catch (error) {
            this.makeToast("danger", "Ошибка", (error as Error).message);
        } finally {
            this.$refs.drop.hide(true);
        }
    }

    private getGuName(code: string): string {
        if (!code) return "";

        return this.curLanguage === "kk"
            ? this.guNameCacheKk[code] ?? code
            : this.guNameCache[code] ?? code;
    }

    private async downLoadReport() {
        const that = this;
        const req: ProjectsMonRequest = {
            user_id: this.user_id,
            year: this.year,
            region: this.region.code,
            abp: null,
            gu: null,
            prg: null,
            dev_type: this.dev_type,
            stage: this.selectedStageCodes,
            expense_code: null,
        };
        if (this.abp?.abp) {
            req.abp = this.abp.abp;
        }
        if (this.gu?.gu) {
            req.gu = this.gu.gu;
        }
        if (this.prg?.prg) {
            req.prg = this.prg.prg;
        }
        if (this.dev_type) {
            req.dev_type = this.dev_type;
        }
        if (this.project?.expense_code) {
            req.expense_code = this.project.expense_code;
        }
        const repdate = new Date();
        const dateString: string = `${repdate.getFullYear()}.${(
            repdate.getMonth() + 1
        )
            .toString()
            .padStart(2, "0")}.${repdate
            .getDate()
            .toString()
            .padStart(2, "0")}`;
        const params: ProjectsMonReport = {
            params: req,
            region_name: this.region[`name_${this.$i18n.locale}`],
            locale: this.$i18n.locale,
        };
        await fetch("/api-py/monitoring/projects/report/409", {
            method: "POST",
            body: JSON.stringify(params),
        })
            .then((resp) => resp.blob())
            .then((blob) => {
                const link = document.createElement("a");
                link.download = `${that.$t(
                    "modules.budget_execution_monitoring.tabs.projects_monitoring"
                )}_${this.region.code}_${this.year}_${dateString}.xlsx`;

                link.href = URL.createObjectURL(blob);
                link.click();
                URL.revokeObjectURL(link.href);
            });
    }

    private show_expense_modal: boolean = false;
    private available_projects: any[] = [];
    private curExpense: any = null;
    private modalSelectedStage: any = null;

    private async onModalOpen(expense: any) {
        if (!this.edit_access) {
            return;
        }
        await this.loadModalProjects(expense);

        if (this.available_projects.length === 0 && !expense.expense_code) {
            return;
        }
        this.curExpense = expense;

        this.modalSelectedStage =
            expense.stage != null
                ? this.modalStages.find(
                      (stage: any) =>
                          String(stage.code) === String(expense.stage)
                  ) ?? null
                : this.modalStages.find(
                      (stage: any) =>
                          String(stage.code) === String(expense.default_stage)
                  ) ?? null;

        this.show_expense_modal = true;
    }

    private onProjectRowClick(project: any) {
        const wasSelected = project.selected;

        for (const pr of this.available_projects) {
            pr.selected = false;
            pr.expanded = false;
        }

        if (wasSelected) {
            return;
        }

        project.selected = true;

        if (project.bips.length > 0) {
            project.expanded = true;

            // если БИП один? то автоматом выбран бип
            if (project.bips.length === 1 && !project.selectedBip) {
                project.selectedBip = project.bips[0].bip_code;
            }
        }
    }

    private hasBipsForProject(project: any): boolean {
        if (!project) {
            return false;
        }

        return Array.isArray(project.bips) && project.bips.length > 0;
    }

    private async onProjectSave() {
        let project: any = null;

        for (const pr of this.available_projects) {
            if (pr.selected) {
                project = pr;
                break;
            }
        }

        if (!project && !this.curExpense.expense_code) {
            return;
        }

        if (!project) {
            const req: SaveProjectRequest = {
                region: this.region.code,
                gu: this.curExpense.gu,
                year: this.year,
                abp: this.curExpense.abp,
                prg: this.curExpense.prg,
                expense_code: null,
                bip_code: null,
                stage: null,
                nom_dog: this.curExpense.nom_dog,
                date_dog: this.curExpense.dt_dog ?? null,
                spf: this.curExpense.spf ?? null,
                user_id: this.user_id,
            };

            const saved = await this.saveProject(req);

            if (saved) {
                this.curExpense.expense_code = null;
                this.curExpense.binding_year = this.year;
                this.curExpense.expense_code_name_ru = null;
                this.curExpense.expense_code_name_kk = null;

                this.curExpense.bip_code = null;
                this.curExpense.bip_code_name_ru = null;
                this.curExpense.bip_code_name_kk = null;

                this.curExpense.stage = null;
                this.modalSelectedStage = null;
            }

            this.searchProjectFilter = "";
            this.show_expense_modal = false;

            return;
        }
        const hasBips = this.hasBipsForProject(project);
        if (hasBips && !project.selectedBip) {
            this.makeToast(
                "warning",
                this.$t(
                    "modules.budget_execution_monitoring.projects_monitoring.messages.attention"
                ),
                this.$t(
                    "modules.budget_execution_monitoring.projects_monitoring.messages.select_bip_for_project"
                )
            );

            return;
        }

        const selectedBip = project.bips?.find(
            (bip: any) => bip.bip_code === project.selectedBip
        );

        const req: SaveProjectRequest = {
            region: this.region.code,
            gu: this.curExpense.gu,
            year: this.year,
            abp: this.curExpense.abp,
            prg: this.curExpense.prg,
            expense_code: project.expense_code,
            bip_code: project.selectedBip ?? null,
            stage: this.modalSelectedStage?.code ?? null,
            nom_dog: this.curExpense.nom_dog,
            date_dog: this.curExpense.dt_dog ?? null,
            spf: this.curExpense.spf ?? null,
            user_id: this.user_id,
        };

        const saved = await this.saveProject(req);

        if (saved) {
            this.curExpense.binding_year = this.year;
            this.curExpense.expense_code = project.expense_code;
            this.curExpense.expense_code_name_ru = project.name_ru;
            this.curExpense.expense_code_name_kk = project.name_kk;

            this.curExpense.bip_code = project.selectedBip ?? null;
            this.curExpense.bip_code_name_ru = selectedBip?.bip_name_ru ?? null;
            this.curExpense.bip_code_name_kk = selectedBip?.bip_name_kk ?? null;

            this.curExpense.stage = this.modalSelectedStage?.code ?? null;
        }

        this.searchProjectFilter = "";
        this.show_expense_modal = false;
    }

    private searchProjectFilter: string = "";

    private get getSortedAndFilterdData() {
        const locale = this.$i18n.locale;
        let data = this.sortTable(
            this.available_projects,
            this.sortModalField,
            this.sortModalDirection
        );
        if (this.searchProjectFilter.trim()) {
            const filter = this.searchProjectFilter.toLowerCase();
            data = data.filter(
                (v) =>
                    (v.expense_code &&
                        v.expense_code
                            .toString()
                            .toLowerCase()
                            .includes(filter)) ||
                    (v[`name_${locale}`] &&
                        v[`name_${locale}`].toLowerCase().includes(filter))
            );
        }

        data.sort((a, b) => (b.selected ? 1 : 0) - (a.selected ? 1 : 0));

        return data;
    }

    private async loadModalProjects(expense: any) {
        const req: any = {
            region: this.region.code,
            year: this.year,
            abp: expense.abp,
            prg: expense.prg,
        };
        await axios
            .post("/api-py/monitoring/projects/available-projects", req)
            .then((response) => {
                if (response.status === 200) {
                    const available_projects = response.data;

                    const grouped = new Map();

                    for (const row of available_projects) {
                        let project = grouped.get(row.expense_code);

                        if (!project) {
                            project = {
                                expense_code: row.expense_code,
                                name_ru: row.name_ru,
                                name_kk: row.name_kk,
                                selected:
                                    row.expense_code === expense.expense_code,
                                expanded:
                                    row.expense_code === expense.expense_code,
                                selectedBip:
                                    row.expense_code === expense.expense_code
                                        ? expense.bip_code ?? null
                                        : null,
                                bips: [],
                            };

                            grouped.set(row.expense_code, project);
                        }

                        if (row.bip_code) {
                            project.bips.push({
                                bip_code: row.bip_code,
                                bip_name_ru: row.bip_name_ru,
                                bip_name_kk: row.bip_name_kk,
                            });
                        }
                    }

                    // привязанного ранее проекта нет в «Трансфертах» года фильтра

                    if (
                        expense.expense_code &&
                        !grouped.has(expense.expense_code)
                    ) {
                        grouped.set(expense.expense_code, {
                            expense_code: expense.expense_code,
                            name_ru: expense.expense_code_name_ru ?? "",
                            name_kk: expense.expense_code_name_kk ?? "",
                            selected: true,
                            expanded: !!expense.bip_code,
                            selectedBip: expense.bip_code ?? null,
                            notInTransfers: true,
                            bips: expense.bip_code
                                ? [
                                      {
                                          bip_code: expense.bip_code,
                                          bip_name_ru:
                                              expense.bip_code_name_ru ?? "",
                                          bip_name_kk:
                                              expense.bip_code_name_kk ?? "",
                                      },
                                  ]
                                : [],
                        });
                    }

                    this.available_projects = Array.from(grouped.values());

                    for (const project of this.available_projects) {
                        this.setNameLang(project, null);

                        // сбрасываем БИП, если он не принадлежит этому проекту
                        if (
                            project.selectedBip &&
                            !project.bips.some(
                                (bip: any) =>
                                    bip.bip_code === project.selectedBip
                            )
                        ) {
                            project.selectedBip = null;
                        }

                        if (project.bips.length === 1 && !project.selectedBip) {
                            project.selectedBip = project.bips[0].bip_code;
                        }
                    }

                    if (
                        this.available_projects.length === 0 &&
                        !expense.expense_code
                    ) {
                        this.makeToast(
                            "danger",
                            this.$t(
                                "modules.budget_execution_monitoring.projects_monitoring.messages.attention"
                            ),
                            this.$t(
                                "modules.budget_execution_monitoring.projects_monitoring.messages.av_projects_not_found"
                            )
                        );
                    }
                }
            });
    }

    private async saveProject(req: SaveProjectRequest) {
        let saved = false;
        await axios
            .post("/api-py/monitoring/projects/data/409/save", req)
            .then((response) => {
                if (response.status === 200) {
                    saved = true;
                    // this.makeToast('info', 'save', 'saved')
                }
            })
            .catch((error: any) => {
                if (
                    error.response?.status === 409 &&
                    error.response?.data.detail.error === "duplicate"
                ) {
                    const nom_dog: string = error.response.data.detail.nom_dog;
                    this.makeToast(
                        "danger",
                        this.$t(
                            "modules.budget_execution_monitoring.projects_monitoring.messages.attention"
                        ),
                        this.$t(
                            "modules.budget_execution_monitoring.projects_monitoring.messages.duplicate_error_message"
                        )
                            .toString()
                            .replace("$nom_dog", nom_dog)
                    );
                } else {
                    this.makeToast(
                        "danger",
                        "save",
                        "Не удалось сохранить данные"
                    );
                }
            });

        return saved;
    }

    private async loadYears() {
        const maxYear: number = new Date().getFullYear();
        let minYear: number = maxYear;
        await axios.get("/api-py/monitoring/projects/min-year").then((res) => {
            if (res.status === 200) {
                minYear = res.data;
            }
        });
        for (let i = maxYear; i >= minYear; i--) {
            this.yearBase.push(i);
        }
        this.yearSelected();
    }

    private async yearSelected() {
        this.regionBase = [];
        this.region = null;
        this.abpBase = [];
        this.abp = null;
        this.guBase = [];
        this.gu = null;
        this.prgBase = [];
        this.prg = null;
        this.projectBase = [];
        this.project = null;
        await this.loadRegions();
    }

    private async loadRegions() {
        const req: any = {
            user_id: this.user_id,
            year: this.year,
        };
        await axios
            .post("/api-py/monitoring/projects/region-list", req)
            .then((res) => {
                if (res.status === 200) {
                    const regionList = res.data;
                    for (const reg of regionList) {
                        this.setNameLang(reg, "code");
                    }
                    this.regionBase = regionList;
                }
            });
        if (this.regionBase.length > 0) {
            this.region = this.regionBase[0];
            await this.regionSelected();
        }
    }

    private async regionSelected() {
        this.abpBase = [];
        this.abp = null;
        this.guBase = [];
        this.gu = null;
        this.prgBase = [];
        this.prg = null;
        this.projectBase = [];
        this.project = null;
        await this.loadAbp();
        await this.loadProjects();
    }

    private async loadAbp() {
        if (!this.region?.code) {
            return;
        }
        const req: any = {
            user_id: this.user_id,
            year: this.year,
            region: this.region?.code,
        };
        await axios
            .post("/api-py/monitoring/projects/abp-list", req)
            .then((res) => {
                if (res.status === 200) {
                    const abpList = res.data;
                    this.setAllOption(abpList, "abp");
                    for (const a of abpList) {
                        this.setNameLang(a, "abp");
                    }
                    this.abpBase = abpList;
                }
            });
        if (this.abpBase.length > 0) {
            this.abp = this.abpBase[0];
            await this.abpSelected();
        }
    }
    private async abpSelected() {
        this.guBase = [];
        this.gu = null;
        this.prgBase = [];
        this.prg = null;
        this.projectBase = [];
        this.project = null;
        await this.loadGu();
        await this.loadProjects();
    }

    private async loadGu() {
        if (!this.abp?.abp) {
            return;
        }
        const req: any = {
            user_id: this.user_id,
            year: this.year,
            region: this.region?.code,
            abp: this.abp?.abp,
        };
        await axios
            .post("/api-py/monitoring/projects/gu-list", req)
            .then((res) => {
                if (res.status === 200) {
                    const guList = res.data;
                    this.setAllOption(guList, "gu");
                    for (const g of guList) {
                        this.setNameLang(g, "gu");
                    }
                    this.guBase = guList;
                }
            });
        if (this.guBase.length > 0) {
            this.gu = this.guBase[0];
            await this.guSelected();
        }
    }

    private async guSelected() {
        this.prgBase = [];
        this.prg = null;
        this.projectBase = [];
        this.project = null;
        await this.loadPrg();
        await this.loadProjects();
    }

    private async loadPrg() {
        if (!this.abp?.abp) {
            return;
        }
        const req: any = {
            user_id: this.user_id,
            year: this.year,
            region: this.region?.code,
            abp: this.abp?.abp,
            gu: this.gu ? this.gu.gu : null,
        };
        await axios
            .post("/api-py/monitoring/projects/prg-list", req)
            .then((res) => {
                if (res.status === 200) {
                    const prgList = res.data;
                    this.setAllOption(prgList, "prg");
                    for (const p of prgList) {
                        this.setNameLang(p, "prg");
                    }
                    this.prgBase = prgList;
                }
            });
        if (this.prgBase.length > 0) {
            this.prg = this.prgBase[0];
            await this.prgSelected();
        }
    }
    private async prgSelected() {
        this.projectBase = [];
        this.project = null;
        await this.loadProjects();
    }

    private async loadProjects() {
        const req: any = {
            user_id: this.user_id,
            year: this.year,
            region: this.region.code,
            abp: null,
            gu: null,
            prg: null,
            expense_code: null,
        };
        if (this.abp?.abp) {
            req.abp = this.abp.abp;
        }
        if (this.gu?.gu) {
            req.gu = this.gu.gu;
        }
        if (this.prg?.prg) {
            req.prg = this.prg.prg;
        }
        if (this.dev_type) {
            req.dev_type = this.dev_type;
        }

        await axios
            .post("/api-py/monitoring/projects/projects-list", req)
            .then((res) => {
                if (res.status === 200) {
                    const projList = res.data;
                    this.setAllOption(projList, "expense_code", true);
                    for (const pr of projList) {
                        this.setNameLang(pr, "expense_code");
                    }
                    this.projectBase = projList;
                }
            });
        if (this.projectBase.length > 0) {
            this.project = this.projectBase[0];
            await this.projectSelected();
        }
    }

    private async projectSelected() {
        // здесь можно дальше триггерить загрузку по project + is_project_linked
    }

    private resetFilter() {
        this.year = new Date().getFullYear();
        this.dev_type = 2;
        this.stage = this.stages[0] ? [this.stages[0]] : [];
        this.yearSelected();
    }

    private async getContractStages() {
        try {
            const response = await axios.get("api-py/dict_contract_stages");
            this.stages = response.data;
            this.modalStages = response.data.filter(
                (stage: any) => stage.code !== null
            );

            this.setAllOption(this.stages, "code");

            this.stages.forEach((stage: any) => {
                this.setNameLang(stage);
            });

            const allOption = this.stages.find(
                (stage: any) => stage.code === null
            );

            this.stage = allOption ? [allOption] : [];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.projects_monitoring.messages.stages_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private getStageName(code: any): string {
        const stage = this.stages.find(
            (item: any) => item.code !== null && item.code == code
        );

        if (!stage) {
            return code;
        }

        switch (this.curLanguage) {
            case "kk":
                return stage.name_kk;
            case "en":
                return stage.name_en;
            default:
                return stage.name_ru;
        }
    }

    private get edit_access() {
        return this.access_level === 2;
    }
    private get read_access() {
        return this.access_level > 0;
    }

    private setAllOption(list: any[], code: string, force: boolean = false) {
        if (list.length > 1 || (list.length === 1 && force)) {
            const obj: any = {};
            obj[code] = null;
            obj.name_ru = "Все";
            obj.name_kk = "Барлығы";
            list.splice(0, 0, obj);
        }
    }

    private setNameLang(obj: any, codeName?: any | null): any {
        const that = this;
        Object.defineProperty(obj, "name", {
            get: function () {
                let txt = obj["name_" + that.$i18n.locale];
                if (txt === undefined) {
                    txt = obj.name_ru;
                }
                if (
                    codeName !== undefined &&
                    codeName !== null &&
                    obj[codeName] !== undefined
                ) {
                    if (obj[codeName]) {
                        txt = obj[codeName] + " - " + txt;
                    }
                }
                return txt;
            },
        });
    }

    private pageChanged() {
        const mainConParent = document.getElementById("main-container");
        if (mainConParent instanceof HTMLElement) {
            mainConParent.scrollTo({ top: 0, behavior: "smooth" });
        }
    }

    private async downloadInfo() {
        if (this.loading) {
            this.makeToast(
                "info",
                String(this.$t("modules.bank_projects.messages.attention_msg")),
                String(
                    this.$t("modules.bank_projects.messages.download_start_msg")
                )
            );
        } else {
            this.loading = true;
            const fileId = this.curLanguage === "kk" ? 53 : 41;
            await axios({
                method: "post",
                url: `/api-py/get-info/${fileId}`,
                responseType: "blob",
                data: null,
            })
                .then((response) => response.data)
                .then((data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    const titleOfFile =
                        this.curLanguage === "kk"
                            ? "Жобалар_мониторингі_нұсқаулығы"
                            : "Инструкция_Мониторинг_проектов";

                    link.setAttribute("download", titleOfFile + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                    this.makeToast(
                        "danger",
                        String(
                            this.$t(
                                "modules.bank_projects.messages.user_guide_req_err_msg"
                            )
                        ),
                        error.toString()
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 5000,
            appendToast: true,
        });
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        const refItem: any = this.$refs[refName];
        setTimeout(() => refItem.$el.focus(), 100);
    }

    private get is_unfilled() {
        if (!this.tableData.length) {
            return false;
        }
        return this.tableData.filter((v) => v.expense_code === null).length > 0;
    }
}
